export enum LimitState {
  ULTIMATE = 'ULTIMATE_LIMIT_STATE',
  SERVICEABILITY = 'SERVICEABILITY_LIMIT_STATE',
  ACCIDENTAL = 'ACCIDENTAL_LIMIT_STATE',
  FATIGUE = 'FATIGUE_LIMIT_STATE',
}
